import { render, staticRenderFns } from "./AllAssessmentHeader.vue?vue&type=template&id=db9831a8&scoped=true"
import script from "./AllAssessmentHeader.vue?vue&type=script&lang=ts"
export * from "./AllAssessmentHeader.vue?vue&type=script&lang=ts"
import style0 from "./AllAssessmentHeader.vue?vue&type=style&index=0&id=db9831a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9831a8",
  null
  
)

export default component.exports